import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Box } from '../Box';

/** Matches `NavItem` `StyledBox` icon cell width. */
const RAIL_NAV_ICON_WIDTH_PX = 24;

/** Short rule width when the side nav is collapsed (Figma). */
const RAIL_DIVIDER_WIDTH_PX = 40;

export const DividerSlot = styled(Box)`
  width: 100%;
  margin: ${({ theme }) => theme.spacing(Spacing.Small)} 0;
`;

export const RailDividerRule = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'light',
})<{ light: boolean }>`
  display: block;
  width: ${RAIL_DIVIDER_WIDTH_PX}px;
  height: 1px;
  margin-left: calc(
    ${({ theme }) => theme.spacing(Spacing.Small)} +
      ${RAIL_NAV_ICON_WIDTH_PX / 2}px - ${RAIL_DIVIDER_WIDTH_PX / 2}px
  );
  background-color: ${({ light, theme }) =>
    light ? theme.palette.neutral[200] : theme.palette.neutral[800]};
`;
